export const PHONE = 470

export const LG_PHONE = 560

export const TABLET = 960
